import React, { useState, useRef } from "react";
import { Row, Col, Card, Button, Input, Drawer, Modal, Typography, message } from "antd";
import { CalendarOutlined } from "@ant-design/icons";
import Close from "../../../../../assets/images/close-x.svg";
import credit from "../../../../../assets/images/creditIcon.svg";
import cash from "../../../../../assets/images/cash.svg";
import CancelArrow from "../../../../../assets/images/cancelArrow.svg";
import { upsertWalletTransactionService, verifyWalletRedemption, validOtp } from "../../../../../services";
import data from "../../../../../constants/retailPos.json";
import messages from "../../../../../errors/messages.en-IN.json";
import sortBy from "lodash/sortBy";
import useAuthStore from "../../../../../stores/useAuthStore";

const { Title } = Typography;

const WalletRedeemDrawer = ({
  isWalletFlag,
  setIswalletFlag,
  amount,
  cart,
  posConfig,
  selectedCustomer,
  setSelectedCustomer,
  selectedPaymentMethod,
  setSelectedPaymentMethod,
  requestPayment,
  currenciesList,
  showPayments,
  setShowPayments,
  setStartIndex,
  getFilteredPaymentMethods,
}) => {
  const tillData = useAuthStore((s) => s.tillData);

  const [submitting, setSubmitting] = useState(false);
  // Ref is the real guard for both submit paths below (OTP verify and the
  // amount-enter redeem); the state only drives the button UI. setSubmitting
  // does not update the captured closure synchronously, so two same-tick
  // invocations would both redeem against the wallet balance.
  const submittingRef = useRef(false);
  const [redeemAmount, setRedeemAmount] = useState(() => {
    return !isNaN(amount) ? parseFloat(amount).toFixed(2) : "0.00";
  });
  const [inputFocused, setInputFocused] = useState("");
  const [showWalletOtpModal, setShowWalletOtpModal] = useState(false);
  const [walletOtp, setWalletOtp] = useState(Array(6).fill(""));
  const [walletOtpError, setWalletOtpError] = useState(false);
  const [walletOtpAmount, setWalletOtpAmount] = useState(null);
  const walletOtpInputsRef = useRef([]);

  // Sync redeemAmount when isWalletFlag or amount changes
  React.useEffect(() => {
    if (isWalletFlag) {
      setRedeemAmount(!isNaN(amount) ? parseFloat(amount).toFixed(2) : "0.00");
    } else {
      setRedeemAmount("");
    }
  }, [isWalletFlag, amount]);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" });
  };

  const handleRedeemWallet = (value) => {
    if (value === "clear") {
      setRedeemAmount("");
    } else if (value === "x") {
      setRedeemAmount((prev) => prev.slice(0, -1));
    } else if (value === ".") {
      if (!redeemAmount.includes(".")) {
        setRedeemAmount((prev) => prev + value);
      }
    } else if (value === "00") {
      if (redeemAmount !== "" || redeemAmount.includes(".")) {
        setRedeemAmount((prev) => prev + value);
      }
    } else {
      setRedeemAmount((prev) => prev + value);
    }
  };

  const handleWalletOtpVerify = async () => {
    if (submittingRef.current || submitting) return;
    submittingRef.current = true;
    setSubmitting(true);
    const otpValue = walletOtp.join("");
    try {
      const validOtpResponse = await validOtp(cart.customer.cwrCustomerId, otpValue, walletOtpAmount, "wallet");
      const status = validOtpResponse?.data?.data?.validOtp?.status;
      if (status === "200") {
        const amountValue = walletOtpAmount;
        const walletBalance = parseFloat(selectedCustomer[0]?.currentBalance || 0);
        const tillData = useAuthStore.getState().tillData || {};
        const bunitId = tillData?.tillAccess?.csBunit?.csBunitId;
        const payload = {
          bunitId,
          customerId: cart.customer.cwrCustomerId,
          trxType: "WD",
          trxValue: amountValue,
          tillId: tillData?.tillAccess.cwrTill.cwrTillID,
          payments: [],
          transactionDetails: "{}",
        };
        const response = await upsertWalletTransactionService(payload);
        if (response?.status !== "200") {
          message.error("Wallet deduction failed");
          return;
        }
        const updatedCustomer = { ...selectedCustomer[0], currentBalance: walletBalance - amountValue };
        setSelectedCustomer([updatedCustomer]);
        requestPayment({ ...selectedPaymentMethod, walletAlreadyDeducted: true }, amountValue.toFixed(2));
        setRedeemAmount("");
        setIswalletFlag(false);
        setShowWalletOtpModal(false);
        setWalletOtp(Array(6).fill(""));
      } else {
        setWalletOtpError(true);
      }
    } catch (err) {
      message.error("Invalid OTP");
    } finally {
      submittingRef.current = false;
      setSubmitting(false);
    }
  };

  if (posConfig?.enable_customer_wallet !== "Y") return null;

  return (
    <>
      <Drawer
        centered
        closable={false}
        width="50%"
        headerStyle={{ padding: "0", borderBottom: "none" }}
        styles={{ body: { padding: "0% 7% 1% 7%", background: "#f3f4f9" } }}
        height="75%"
        placement="bottom"
        footer={null}
        open={isWalletFlag}
        onCancel={() => {
          setSelectedPaymentMethod({});
          setIswalletFlag(false);
          setRedeemAmount("");
        }}
        title={
          <div style={{ display: "flex", alignItems: "center", fontSize: "1vw" }}>
            <p style={{ fontSize: "1.5em", fontWeight: "500", color: "#0F0718", flex: 1, textAlign: "center" }}>Customer Wallet</p>
            <img
              src={Close}
              onClick={() => {
                setSelectedPaymentMethod({});
                setShowPayments(JSON.parse(localStorage.getItem("initialShowPayments")));
                setIswalletFlag(false);
                let PaymentMethods = getFilteredPaymentMethods() || [];
                const isPreOrderPage = window.location.pathname.includes("/preorder");
                if (isPreOrderPage) {
                  const isRefundScenario = amount < 0 && selectedPaymentMethod?.name?.toLowerCase() === "cash";
                  const maxPaymentsToShow = isRefundScenario ? 3 : 3;
                  let payments =
                    PaymentMethods.length > maxPaymentsToShow
                      ? sortBy(PaymentMethods, "sequenceNo").slice(
                          0,
                          tillData?.tillAccess?.csBunit?.b2cCustomer?.cwrCustomerId === cart?.customer?.cwrCustomerId && PaymentMethods.length === maxPaymentsToShow
                            ? maxPaymentsToShow
                            : cart.layAway === "Y"
                              ? maxPaymentsToShow
                              : maxPaymentsToShow
                        )
                      : PaymentMethods;
                  setShowPayments(payments);
                  setStartIndex((cart.layAway === "Y" || cart?.creditSale === "Y") && payments.length >= maxPaymentsToShow ? maxPaymentsToShow : payments.length);
                }
                setRedeemAmount("");
              }}
              style={{ marginLeft: "auto", paddingBottom: "4vh", paddingTop: "2vh", cursor: "pointer", width: "1.5vw" }}
            />
          </div>
        }
      >
        <Row gutter={[24, 24]} style={{ height: "100%" }}>
          <Col span={12}>
            {selectedCustomer && selectedCustomer[0] ? (
              <>
                <Row gutter={[16, 0]} style={{ marginBottom: "1rem" }}>
                  <Col span={8}>
                    <Card
                      bodyStyle={{ height: "20vh", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", padding: 0 }}
                      style={{ borderRadius: "8px", textAlign: "center", border: "1px solid #e8e8e8", backgroundColor: "#fff" }}
                    >
                      <img src={credit || "/placeholder.svg"} style={{ height: "3vh", paddingRight: "5px", marginTop: "2vh", marginBottom: "2vh" }} alt="" />
                      <h4 style={{ margin: 0, color: "#666", fontSize: "1rem" }}>Current Balance</h4>
                      <h2 style={{ margin: "0.5rem", color: "#28a745", fontSize: "1rem", fontWeight: "bold" }}>
                        {currenciesList && currenciesList.length > 0 && currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}
                        {selectedCustomer[0]?.currentBalance?.toFixed(2) || "0.00"}
                        {currenciesList && currenciesList.length > 0 && currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""}
                      </h2>
                    </Card>
                  </Col>
                  <Col span={8}>
                    <Card
                      bodyStyle={{ height: "20vh", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", padding: 0 }}
                      style={{ borderRadius: "8px", textAlign: "center", border: "1px solid #e8e8e8", backgroundColor: "#fff" }}
                    >
                      <img src={cash || "/placeholder.svg"} style={{ height: "3vh", paddingRight: "5px", marginTop: "2vh", marginBottom: "2vh" }} alt="" />
                      <h4 style={{ margin: 0, color: "#666", fontSize: "1rem" }}>Total Spent</h4>
                      <h2 style={{ margin: "0.5rem", color: "#0F0718", fontSize: "1rem", fontWeight: "bold" }}>
                        {currenciesList && currenciesList.length > 0 && currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}
                        {selectedCustomer[0]?.totalSpent?.toFixed(2) || "0.00"}
                        {currenciesList && currenciesList.length > 0 && currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""}
                      </h2>
                    </Card>
                  </Col>
                  <Col span={8}>
                    <Card
                      bodyStyle={{ height: "20vh", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", padding: 0 }}
                      style={{ borderRadius: "8px", textAlign: "center", border: "1px solid #e8e8e8", backgroundColor: "#fff" }}
                    >
                      <CalendarOutlined style={{ height: "3vh", fontSize: "1.7em", paddingRight: "5px", marginTop: "2vh", marginBottom: "2vh" }} />
                      <h4 style={{ margin: 0, color: "#666", fontSize: "1rem" }}>Member Since</h4>
                      <h2 style={{ margin: "0.5rem 0", color: "#0F0718", fontSize: "1rem", fontWeight: "bold" }}>
                        {selectedCustomer[0]?.joinDate ? formatDate(selectedCustomer[0].joinDate) : ""}
                      </h2>
                    </Card>
                  </Col>
                </Row>
                <Row gutter={[16, 16]} style={{ marginTop: "1rem" }}>
                  <Col span={12}>
                    <div style={{ textAlign: "left", color: "#333" }}>
                      <p>
                        <strong>Wallet Balance</strong>
                      </p>
                      <h2 style={{ margin: "0.5rem", color: "#0F0718", fontSize: "1rem" }}>
                        {currenciesList && currenciesList.length > 0 && currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}
                        {selectedCustomer[0]?.currentBalance?.toFixed(2) || "0.00"}
                        {currenciesList && currenciesList.length > 0 && currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""}
                      </h2>
                    </div>
                  </Col>
                  <Col span={12}>
                    <div style={{ textAlign: "left", color: "#333" }}>
                      <p>
                        <strong>Bill Amount</strong>
                      </p>
                      <h2 style={{ margin: "0.5rem", color: "#0F0718", fontSize: "1rem" }}>
                        {currenciesList && currenciesList.length > 0 && currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}
                        {!isNaN(cart.total) ? parseFloat(cart.total).toFixed(2) : cart.total.toFixed(2)}
                        {currenciesList && currenciesList.length > 0 && currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""}
                      </h2>
                    </div>
                  </Col>
                  <Col span={12}>
                    <div style={{ textAlign: "left", color: "#333" }}>
                      <p>
                        <strong>Remaining Due</strong>
                      </p>
                      <h2 style={{ margin: "0.5rem", color: "#0F0718", fontSize: "1rem" }}>
                        {currenciesList && currenciesList.length > 0 && currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}
                        {!isNaN(amount) ? parseFloat(amount).toFixed(2) : "0.00"}
                        {currenciesList && currenciesList.length > 0 && currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""}
                      </h2>
                    </div>
                  </Col>
                </Row>
              </>
            ) : (
              <div style={{ textAlign: "center", padding: "1rem", color: "#666" }}>
                <h4>No customer selected</h4>
              </div>
            )}
          </Col>

          <Col span={12}>
            <Col span={20} pull={2} push={2}>
              <label>
                <span style={{ color: "#0F0718", fontSize: "1.25em", fontWeight: "500", marginBottom: "3vh" }}>Redeem Wallet Amount</span>
              </label>
              <Input
                id="amountNumber"
                value={redeemAmount}
                onChange={(e) => {
                  const value = e.target.value;
                  if (value === "" || /^(\d*\.?\d*)$/.test(value)) setRedeemAmount(value);
                }}
                onFocus={() => setInputFocused("amount")}
                size="large"
                onPressEnter={(e) => e.preventDefault()}
                allowClear={false}
                style={{ ...data.posScreenStyles.orderHistoryModal.cashManagmentSearchInput, padding: "1.5vh 1vw", fontSize: "1em", marginBottom: "2vh", border: "1px solid gray" }}
              />
            </Col>
            <Row style={{ padding: "0 8%" }} gutter={[8, 6]}>
              {["1", "2", "3"].map((n) => (
                <Col span={6} key={n}>
                  <button
                    id={`sm-amount-button${n}`}
                    className="amt-dial-btn-gift"
                    onClick={(e) => {
                      handleRedeemWallet(n);
                      e.preventDefault();
                    }}
                  >
                    {n}
                  </button>
                </Col>
              ))}
              <Col span={6}>
                <button
                  className="amt-dial-btn-gift"
                  id="sm-amount-buttonRemove"
                  onClick={(e) => {
                    handleRedeemWallet("x");
                    e.preventDefault();
                  }}
                  style={{ display: "flex", justifyContent: "center", alignItems: "center" }}
                >
                  <img src={CancelArrow} alt="back space" style={{ width: "25px", height: "15px", objectFit: "contain" }} />
                </button>
              </Col>
              {["4", "5", "6"].map((n) => (
                <Col span={6} key={n}>
                  <button
                    id={`sm-amount-button${n}`}
                    className="amt-dial-btn-gift"
                    onClick={(e) => {
                      handleRedeemWallet(n);
                      e.preventDefault();
                    }}
                  >
                    {n}
                  </button>
                </Col>
              ))}
              <Col span={6}>
                <button
                  onClick={(e) => {
                    handleRedeemWallet("clear");
                    e.preventDefault();
                  }}
                  id="sm-amount-addQuantity"
                  className="amt-dial-btn-gift"
                >
                  Clear
                </button>
              </Col>
              <Col span={18}>
                <Row gutter={[8, 6]}>
                  {["7", "8", "9"].map((n) => (
                    <Col span={8} key={n}>
                      <button
                        id={`sm-amount-button${n}`}
                        className="amt-dial-btn-gift"
                        onClick={(e) => {
                          handleRedeemWallet(n);
                          e.preventDefault();
                        }}
                      >
                        {n}
                      </button>
                    </Col>
                  ))}
                  <Col span={8}>
                    <button
                      id="sm-amount-button0"
                      className="amt-dial-btn-gift"
                      onClick={(e) => {
                        handleRedeemWallet("0");
                        e.preventDefault();
                      }}
                    >
                      0
                    </button>
                  </Col>
                  <Col span={8}>
                    <button
                      id="sm-amount-buttonDot"
                      className="amt-dial-btn-gift"
                      onClick={(e) => {
                        handleRedeemWallet(".");
                        e.preventDefault();
                      }}
                    >
                      .
                    </button>
                  </Col>
                  <Col span={8}>
                    <button
                      id="sm-amount-button00"
                      className="amt-dial-btn-gift"
                      onClick={(e) => {
                        handleRedeemWallet("00");
                        e.preventDefault();
                      }}
                    >
                      00
                    </button>
                  </Col>
                </Row>
              </Col>
              <Col span={6}>
                <button
                  id="sm-amount-buttonEnter"
                  className="amt-dial-btn-gift2"
                  disabled={submitting}
                  onClick={async (e) => {
                    e.preventDefault();
                    if (submittingRef.current || submitting) return;
                    submittingRef.current = true;
                    setSubmitting(true);
                    try {
                    const amountValue = parseFloat(redeemAmount);
                    const walletBalance = parseFloat(selectedCustomer[0]?.currentBalance || 0);
                    const remainingDue = parseFloat(amount);

                    if (!redeemAmount || isNaN(amountValue) || amountValue <= 0) {
                      message.warning(`${messages.info.valid_amount}`);
                      return;
                    }
                    if (amountValue > walletBalance) {
                      message.warning(`${messages.warnings.payment.redeem_wallet_amount_exceeds}`);
                      return;
                    }
                    if (amountValue > remainingDue) {
                      message.warning(`${messages.warnings.payment.redeem_wallet_amount_exceeds_due}`);
                      return;
                    }

                    const tillData = useAuthStore.getState().tillData || {};
                    const bunitId = tillData?.tillAccess?.csBunit?.csBunitId;

                    try {
                      if (posConfig?.enableLoyalty === "Y") {
                        const res = await verifyWalletRedemption(cart.customer.cwrCustomerId, bunitId, amountValue);
                        const status = res?.data?.data?.verifyWalletRedemption?.status;
                        if (status === "200") {
                          setWalletOtpAmount(amountValue);
                          setShowWalletOtpModal(true);
                          return;
                        } else {
                          message.error(res?.data?.data?.verifyWalletRedemption?.message);
                          return;
                        }
                      }

                      const payload = {
                        bunitId,
                        customerId: cart.customer.cwrCustomerId,
                        trxType: "WD",
                        trxValue: amountValue,
                        tillId: tillData?.tillAccess.cwrTill.cwrTillID,
                        payments: [],
                        transactionDetails: "{}",
                      };
                      const response = await upsertWalletTransactionService(payload);
                      if (response?.status !== "200") {
                        message.error("Wallet deduction failed");
                        return;
                      }
                      const updatedCustomer = { ...selectedCustomer[0], currentBalance: walletBalance - amountValue };
                      setSelectedCustomer([updatedCustomer]);
                      requestPayment({ ...selectedPaymentMethod, walletAlreadyDeducted: true }, amountValue.toFixed(2));
                      setRedeemAmount("");
                      setIswalletFlag(false);
                      localStorage.removeItem("walletDataForCardIntegration");
                    } catch (err) {
                      message.error("Wallet deduction error");
                    }
                    } finally {
                      submittingRef.current = false;
                      setSubmitting(false);
                    }
                  }}
                >
                  Enter
                </button>
              </Col>
            </Row>
          </Col>
        </Row>
      </Drawer>

      <Modal open={showWalletOtpModal} footer={null} closable={false} centered styles={{ body: { textAlign: "center", padding: "40px 24px" } }}>
        <Title level={4}>Verify OTP for Wallet Redemption</Title>
        <p style={{ marginBottom: 20 }}>Redeeming wallet amount: {walletOtpAmount}</p>
        <Row justify="center" gutter={8} style={{ marginBottom: 28 }}>
          {walletOtp.map((digit, idx) => (
            <Col key={idx}>
              <Input
                maxLength={1}
                value={digit}
                ref={(el) => (walletOtpInputsRef.current[idx] = el)}
                onChange={(e) => {
                  const newOtp = [...walletOtp];
                  newOtp[idx] = e.target.value;
                  setWalletOtp(newOtp);
                  if (e.target.value && idx < 5) {
                    walletOtpInputsRef.current[idx + 1]?.focus();
                  }
                }}
                onKeyDown={(e) => {
                  if (e.key === "Backspace" && !walletOtp[idx] && idx > 0) {
                    const newOtp = [...walletOtp];
                    newOtp[idx - 1] = "";
                    setWalletOtp(newOtp);
                    walletOtpInputsRef.current[idx - 1]?.focus();
                  }
                }}
                style={{
                  width: 48,
                  height: 48,
                  textAlign: "center",
                  fontSize: 20,
                  borderRadius: 8,
                  border: walletOtpError ? "1.5px solid red" : "1.5px solid #d9d9d9",
                }}
              />
            </Col>
          ))}
        </Row>
        {walletOtpError && <p style={{ color: "red", marginBottom: 16 }}>Invalid OTP. Try again.</p>}
        <Row justify="center" gutter={12}>
          <Col>
            <Button
              onClick={() => {
                setShowWalletOtpModal(false);
                setWalletOtp(Array(6).fill(""));
                setWalletOtpError(false);
              }}
            >
              Cancel
            </Button>
          </Col>
          <Col>
            <Button style={{ color: "white", background: "#253856", borderColor: "#253856" }} type="primary" onClick={handleWalletOtpVerify} disabled={walletOtp.includes("") || submitting} loading={submitting}>
              Verify OTP
            </Button>
          </Col>
        </Row>
      </Modal>
    </>
  );
};

export default WalletRedeemDrawer;
